import React from "react";
import { Chip } from "@mui/material";

const DSChip = (props: React.ComponentProps<typeof Chip>) => {
  return <Chip {...props} />;
};

export default DSChip;
